
import Vue from 'vue'

export default Vue.extend({
   name: 'TextDisplay',
   props: {
      label: String,
      value: [String, Boolean, Number],
   },
})
